import { Toast, ToastContainer } from "react-bootstrap";
import { useToast, ToastVariant } from "@/hooks/useToast";
import AwesomeIcon from "@icons/AwesomeIcon";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const getVariantStyles = (
  variant: ToastVariant
): { bg: string; icon: IconProp; iconColor: string } => {
  switch (variant) {
    case "success":
      return { bg: "success", icon: "check" as IconProp, iconColor: "#fff" };
    case "error":
      return { bg: "danger", icon: "times" as IconProp, iconColor: "#fff" };
    case "warning":
      return { bg: "warning", icon: "bell" as IconProp, iconColor: "#000" };
    case "info":
    default:
      return { bg: "info", icon: "bell" as IconProp, iconColor: "#fff" };
  }
};

const SntToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToast();

  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
      {toasts.map((toast) => {
        const styles = getVariantStyles(toast.variant);
        return (
          <Toast
            key={toast.id}
            onClose={() => removeToast(toast.id)}
            bg={styles.bg}
            autohide={false}
          >
            <Toast.Body className="d-flex align-items-center text-white">
              <AwesomeIcon
                icon={styles.icon}
                className="me-2"
                style={{ color: styles.iconColor }}
              />
              <span style={{ color: toast.variant === "warning" ? "#000" : "#fff" }}>
                {toast.message}
              </span>
              <button
                type="button"
                className="btn-close btn-close-white ms-auto"
                onClick={() => removeToast(toast.id)}
                aria-label="Close"
              />
            </Toast.Body>
          </Toast>
        );
      })}
    </ToastContainer>
  );
};

export default SntToastContainer;
